module.exports = __webpack_public_path__ + "img/亞聯_LOGO_320x150.29c33a38.png";